export const NavbarDetails = [
  {
    label: "NEW ARRIVALS",
    image:
      "https://img.mytheresa.com/media/static/raw/cms/l/MW_HP_2022_CW51/BIG1/BIG_DESKTOP_2X_20221216132342.jpg?imwidth=1180&imdensity=1",

    children: [
      {
        id: 1,
        subLabel: "SHOP BY CATEGORY",
        subChildren: [
          {
            label: "Current Week",
            href: "/products",
          },
          {
            label: "Previous Weeks",
            href: "/products",
          },
          {
            label: "Tailoring Edit",
            href: "/products",
          },
          {
            label: "Loungewear",
            href: "/products",
          },
          {
            label: "Outdoor & Activewear",
            href: "/products",
          },
          {
            label: "Cold Weather Edit",
            href: "/products",
          },
          {
            label: "The Ski Edit",
            href: "/products",
          },
          {
            label: "Skiwear",
            href: "/products",
          },
          {
            label: "Swimwear",
            href: "/products",
          },
          {
            label: "Shorts",
            href: "/products",
          },
        ],
      },
      {
        id: 2,
        subLabel: "JUST IN",
        subChildren: [
          {
            label: "Clothing",
            href: "/products",
          },
          {
            label: "Accessories",
            href: "/products",
          },
          {
            label: "New Season",
            href: "/products",
          },
          {
            label: "Winter Clothing",
            href: "/products",
          },
        ],
      },
    ],
  },
  {
    label: "DESIGNER",
    image:
      "https://img.mytheresa.com/media/static/raw/cms/l/MW_HP_2022_CW50/FLYOUTS/NA_FLYOUT-_9__20221215105354.jpg",

    children: [
      {
        id: 1,
        subLabel: "TOP 25",
        subChildren: [
          {
            label: "Biba",
            href: "/products?brand=Biba",
          },
          {
            label: "Libas",
            href: "/products?brand=Libas",
          },
          {
            label: "Anouk",
            href: "/products?brand=Anouk",
          },
          {
            label: "SPACES",
            href: "/products?brand=SPACES",
          },
          {
            label: "Inddus",
            href: "/products?brand=Inddus",
          },
          {
            label: "SOJANYA",
            href: "/products?brand=SOJANYA",
          },
          {
            label: "Aj DEZInES",
            href: "/products?brand=Aj DEZInES",
          },
          {
            label: "Fabindia",
            href: "/products?brand=Fabindia",
          },
          {
            label: "DEYANN",
            href: "/products?brand=DEYANN",
          },
          {
            label: "Zotw",
            href: "/products?brand=Zotw",
          },
        ],
      },
      {
        id: 2,
        subLabel: "10+",
        subChildren: [
          {
            label: "Manu",
            href: "/products?brand=Manu",
          },
          {
            label: "Anouk",
            href: "/products?brand=Anouk",
          },
          {
            label: "Svanik",
            href: "/products?brand=Svanik",
          },
          {
            label: "Global Desi",
            href: "/products?brand=Global Desi",
          },
          {
            label: "IMARA",
            href: "/products?brand=IMARA",
          },
          {
            label: "House of Pataudi",
            href: "/products?brand=House of Pataudi",
          },
          {
            label: "The White Willow",
            href: "/products?brand=The White Willow",
          },
          {
            label: "AKS",
            href: "/products?brand=AKS",
          },
          {
            label: "RARE ROOTS",
            href: "/products?brand=RARE ROOTS",
          },
          {
            label: "I Know",
            href: "/products?brand=I Know",
          },
          {
            label: "SG YUVRAJ",
            href: "/products?brand=SG YUVRAJ",
          },
          {
            label: "TABARD",
            href: "/products?brand=TABARD",
          },
        ],
      },
      {
        id: 3,
        subLabel: "SHOP BY CATEGORY",
        subChildren: [
          {
            label: "Current Week",
            href: "/products",
          },
          {
            label: "Previous Weeks",
            href: "/products",
          },
          {
            label: "Tailoring Edit",
            href: "/products",
          },
        ],
      },
    ],
  },
  {
    label: "CLOTHING",
    image:
      "https://img.mytheresa.com/media/static/raw/cms/l/MW_HP_2022_CW51/BIG1/BIG_DESKTOP_2X_20221216132342.jpg?imwidth=1180&imdensity=1",

    children: [
      {
        id: 1,
        subLabel: "SHOP BY CATEGORY",
        subChildren: [
          {
            label: "Jackets",
            href: "/products",
          },
          {
            label: "Coats",
            href: "/products",
          },
          {
            label: "Knitwear",
            href: "/products",
          },
          {
            label: "Sweats",
            href: "/products",
          },
          {
            label: "Shirts",
            href: "/products",
          },
          {
            label: "Pants",
            href: "/products",
          },
          {
            label: "Tailored Jackets & Blazers",
            href: "/products",
          },
          {
            label: "Tailoring",
            href: "/products",
          },
          {
            label: "Jeans",
            href: "/products",
          },
          {
            label: "T-shirts",
            href: "/products",
          },
          {
            label: "Polo shirts",
            href: "/products",
          },
          {
            label: "Activewear",
            href: "/products",
          },
          {
            label: "Skiwear",
            href: "/products",
          },
          {
            label: "Swimwear",
            href: "/products",
          },
          {
            label: "Shorts",
            href: "/products",
          },
        ],
      },
      {
        id: 2,
        subLabel: "TOP BRANDS",
        subChildren: [
          {
            label: "Biba",
            href: "/products?brand=Biba",
          },
          {
            label: "Libas",
            href: "/products?brand=Libas",
          },
          {
            label: "Anouk",
            href: "/products?brand=Anouk",
          },
          {
            label: "SPACES",
            href: "/products?brand=SPACES",
          },
          {
            label: "Inddus",
            href: "/products?brand=Inddus",
          },
          {
            label: "SOJANYA",
            href: "/products?brand=SOJANYA",
          },
          {
            label: "Aj DEZInES",
            href: "/products?brand=Aj DEZInES",
          },
          {
            label: "Fabindia",
            href: "/products?brand=Fabindia",
          },
          {
            label: "DEYANN",
            href: "/products?brand=DEYANN",
          },
          {
            label: "Zotw",
            href: "/products?brand=Zotw",
          },
        ],
      },
      {
        id: 3,
        subLabel: "DISCOVER",
        subChildren: [
          {
            label: "New clothing arrivals",
            href: "/products",
          },
          {
            label: "Essential clothing",
            href: "/products",
          },
          {
            label: "Exclusive clothing",
            href: "/products",
          },
        ],
      },
    ],
  },
  {
    label: "ACCESSORIES",
    image:
      "https://img.mytheresa.com/media/static/raw/cms/l/MW_HP_2022_CW51/BIG1/BIG_DESKTOP_2X_20221216132342.jpg?imwidth=1180&imdensity=1",

    children: [
      {
        id: 1,
        subLabel: "TOP BRANDS",
        subChildren: [
          {
            label: "Biba",
            href: "/products?brand=Biba",
          },
          {
            label: "Libas",
            href: "/products?brand=Libas",
          },
          {
            label: "Anouk",
            href: "/products?brand=Anouk",
          },
          {
            label: "SPACES",
            href: "/products?brand=SPACES",
          },
          {
            label: "Inddus",
            href: "/products?brand=Inddus",
          },
          {
            label: "SOJANYA",
            href: "/products?brand=SOJANYA",
          },
          {
            label: "Aj DEZInES",
            href: "/products?brand=Aj DEZInES",
          },
          {
            label: "Fabindia",
            href: "/products?brand=Fabindia",
          },
          {
            label: "DEYANN",
            href: "/products?brand=DEYANN",
          },
          {
            label: "Zotw",
            href: "/products?brand=Zotw",
          },
        ],
      },
      {
        id: 2,
        subLabel: "DISCOVER",
        subChildren: [
          {
            label: "New clothing arrivals",
            href: "/products",
          },
          {
            label: "Essential clothing",
            href: "/products",
          },
          {
            label: "Exclusive clothing",
            href: "/products",
          },
        ],
      },
    ],
  },
  {
    label: "SALE",
    image:
      "https://img.mytheresa.com/media/static/raw/cms/l/MW_HP_2022_CW51/BIG1/BIG_DESKTOP_2X_20221216132342.jpg?imwidth=1180&imdensity=1",

    children: [
      {
        id: 1,
        subLabel: "DISCOVER",
        subChildren: [
          {
            label: "Clothing",
            href: "/products",
          },
          {
            label: "Shoes",
            href: "/products",
          },
          {
            label: "Accessories",
            href: "/products",
          },
          {
            label: "Previous seasons",
            href: "/products",
          },
        ],
      },
      {
        id: 2,
        subLabel: "JUST IN",
        subChildren: [
          {
            label: "Clothing",
            href: "/products",
          },
          {
            label: "Accessories",
            href: "/products",
          },
          {
            label: "New Season",
            href: "/products",
          },
          {
            label: "Winter Clothing",
            href: "/products",
          },
        ],
      },
      {
        id: 2,
        subLabel: "10+",
        subChildren: [
          {
            label: "Manu",
            href: "/products?brand=Manu",
          },
          {
            label: "Anouk",
            href: "/products?brand=Anouk",
          },
          {
            label: "Svanik",
            href: "/products?brand=Svanik",
          },
          {
            label: "Global Desi",
            href: "/products?brand=Global Desi",
          },
          {
            label: "IMARA",
            href: "/products?brand=IMARA",
          },
          {
            label: "House of Pataudi",
            href: "/products?brand=House of Pataudi",
          },
          {
            label: "The White Willow",
            href: "/products?brand=The White Willow",
          },
        ],
      },
    ],
  },
];

// const NAV_ITEMS = [
//     {
//       label: "NEW ARRIVALS",
//       children: [
//         {
//           label: "Explore Design Work",
//           subLabel: "Trending Design to inspire you",
//           href: "/products",
//         },
//         {
//           label: "New & Noteworthy",
//           subLabel: "Up-and-coming Designers",
//           href: "#",
//         },
//       ],
//     },
//     {
//       label: "DESIGNER",
//       children: [
//         {
//           label: "Job Board",
//           subLabel: "Find your dream design job",
//           href: "#",
//         },
//         {
//           label: "Freelance Projects",
//           subLabel: "An exclusive list for contract work",
//           href: "#",
//         },
//       ],
//     },
//     {
//       label: "Learn Design",
//       href: "#",
//     },
//     {
//       label: "Hire Designers",
//       href: "#",
//     },
//   ];
